module.exports = __webpack_public_path__ + "static/media/ottawa.6f618a4e.jpg";